import React from "react";
import "@frameworks/salesjourney/stylesheets/components/Features/Downloads/DownloadsCard.scss";
import Edelicon from "../../../../shared-library/components/Generic/Edelicon";
export var EStatus;
(function (EStatus) {
    EStatus["FAILED"] = "Failed";
    EStatus["COMPLETED"] = "Completed";
    EStatus["PENDING"] = "Pending";
})(EStatus || (EStatus = {}));
var DownloadCard = function (props) {
    var rightAlignedBLock = function () {
        switch (props === null || props === void 0 ? void 0 : props.statusText) {
            case EStatus.FAILED:
                return (React.createElement("div", { className: "DMSanM_14_500 status-block " },
                    React.createElement("span", { className: "bg-pale-pink  status-text rounded expired-status" },
                        React.createElement("span", { className: "txt-racing-red" }, props === null || props === void 0 ? void 0 : props.statusText)),
                    React.createElement("span", { className: "status-button" }, false && (React.createElement(Edelicon, { className: "edel-icon-refresh hand_cursor", onClick: function () { } })))));
            case EStatus.COMPLETED:
                return (React.createElement("div", { className: "DMSanM_14_500 status-block " },
                    React.createElement("span", { className: "bg-pale-pink  status-text rounded completed-status" },
                        React.createElement("span", { className: "txt-racing-red" }, props === null || props === void 0 ? void 0 : props.statusText)),
                    React.createElement("span", { className: "status-button" },
                        React.createElement(Edelicon, { className: "edel-icon-download-coloured hand_cursor", paths: 2, onClick: function (e) {
                                e.stopPropagation();
                                props === null || props === void 0 ? void 0 : props.downloadFile(props === null || props === void 0 ? void 0 : props.fileInfo);
                            } }))));
            case EStatus.PENDING:
                return (React.createElement("div", { className: "DMSanM_14_500 status-block " },
                    React.createElement("span", { className: "bg-pale-pink  status-text rounded  pending-status" },
                        React.createElement("span", { className: "txt-racing-red" }, props === null || props === void 0 ? void 0 : props.statusText)),
                    React.createElement("span", { className: "status-button" }, (props === null || props === void 0 ? void 0 : props.showReset) && React.createElement(Edelicon, { className: "edel-icon-refresh" }))));
        }
    };
    return (React.createElement("div", { className: "download-card-primary-block bg_white rounded" },
        React.createElement("div", { className: " left-block" },
            React.createElement(Edelicon, { className: "edel-icon-blank-page" }),
            React.createElement("div", { className: " d-flex flex-column text-block" },
                React.createElement("span", { className: "DMSans_16_500 ", onClick: function (e) {
                        e.stopPropagation();
                        (props === null || props === void 0 ? void 0 : props.onClick) && (props === null || props === void 0 ? void 0 : props.onClick());
                    } }, props === null || props === void 0 ? void 0 : props.text),
                React.createElement("span", { className: "txt_secondary-gray DMSanM_14_500" }, props === null || props === void 0 ? void 0 : props.deliveryTime))),
        React.createElement("div", { className: "middle-aligned-block" }),
        React.createElement("div", { className: "right-aligned-block" }, rightAlignedBLock())));
};
export default DownloadCard;
